import { AfterContentInit, Component, ElementRef } from '@angular/core';

@Component({
    selector: 'app-dropdown-menu',
    templateUrl: './app-dropdown-menu.component.html'
})
export class AppDropdownMenuComponent {
    
    constructor(private _element: ElementRef) { 
        document.addEventListener('click', this.onClick.bind(this));
    }

    show: boolean = false;

    onClick(event) {
        if (!this._element.nativeElement.contains(event.target)) 
        {
            this.show = false;
        }
    }
}